import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReferentielEnum } from 'src/app/utils/enums/referentiel-enum';
import { SortEnum } from 'src/app/utils/enums/sort-enum';
import { TypeEnum } from 'src/app/utils/interfaces/new/Critere';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { CritereNode, CritereRecherche, LabelValue, RechercheMultiCriteres } from 'src/app/utils/interfaces/new/recherche';
import { ResultatPatient } from 'src/app/utils/interfaces/new/resultat-patient.interface';
import { environment } from 'src/environments/environment';
import { CorrespondantService } from '../correspondant/correspondant.service';
import { CritereService } from '../critere/critere.service';
import { FiltresService } from '../filtres/filtres.service';
import { GroupementCriteresService } from '../groupement-criteres/groupement-criteres.service';
import { CabinetService } from '../office/cabinet.service';
import { ReferentielService } from '../referentiel/referentiel.service';
import { SnackbarService } from '../snackbar/snackbar.service';
import { StringUtilsService } from '../string-utils/string-utils.service';
import { MultiprofessionalProtocolService } from '../multiprofessional-protocol/multiprofessional-protocol.service';

const TREE_DATA: CritereNode[] = [
  {
    name: 'Etat Civil',
    children: [
      { name: 'Nom', type: 'string' },
      { name: 'Nom de naissance', type: 'string'},
      { name: 'Nom d\'usage', type: 'string'},
      { name: 'Prénom', type: 'string' },
      { name: 'Prénom d\'usage', type: 'string'},
      { name: 'Date de naissance', type: 'date' },
      { name: 'Age', type: 'number' },
      { name: 'Numéro de sécu', type: 'string' },
      { name: 'Sexe', type: 'sexe' },
      { name: 'Code postal', type: 'string' },
      { name: 'Commune', type: 'string' },
      { name: 'Créateur', type: 'utilisateur' },
      { name: 'Profession', type: 'string' },
      { name: 'Téléphone', type: 'string' },
      { name: 'Portable', type: 'string' }
    ]
  },
  {
    name: 'Situation patient',
    children: [
      { name: 'ALD', type: 'ouinon' },
      { name: 'Option Référent', type: 'ouinon' },
      { name: 'CMU', type: 'ouinon' },
      { name: 'Paiement Mutuelle', type: 'ouinon' },
      { name: 'Médecin traitant', type: 'ouinon' },
      { name: 'Correspondant', type: 'correspondant' },
      { name: 'Inclus dans un protocole', type: 'protocole' },
    ]
  },
  {
    name: 'Informations médicales',
    children: [
      { name: 'Poids', type: 'number' },
      { name: 'Taille', type: 'number' },
      { name: 'IMC', type: 'number' },
      { name: 'Taux créatinine', type: 'number' },
      { name: 'DFG', type: 'number' },
    ]
  },
  {
    name: 'Antécédents et divers',
    children: [
      {
        name: 'ATCD personnel', children: [
          { name: 'ATCD perso en texte', type: 'string' },
          { name: 'ATCD perso code CIM 10', type: 'string' },
          { name: 'ATCD perso commentaire', type: 'string' }
        ]
      },
      {
        name: 'ATCD familial', children: [
          { name: 'ATCD fam en texte', type: 'string' },
          { name: 'ATCD fam code CIM 10', type: 'string' },
          { name: 'ATCD fam commentaire', type: 'string' }
        ]
      },
      { name: 'Allergie', type: 'allergie' },
      { name: 'Pathologie', type: 'pathologie' },
      { name: 'Histoire', type: 'historique' },
      { name: 'Maladie ALD', type: 'ald' }
    ]
  },
  {
    name: 'Consultations',
    children: [
      { name: 'Date de consultation', type: 'date' },
      { name: 'Créateur de la consultation', type: 'utilisateur' },
      { name: 'Titre de la consultation', type: 'string' },
      { name: 'Textes de consultation', type: 'string' },
      { name: 'Statut de la consultation', type: 'statut-consultation' },
      { name: 'Groupe de la consultation', type: 'groupe-consultation' },
      { name: 'Type de la consultation', type: 'type-consultation' },
      {
        name: 'Critère',
        type: 'critere'
      },
      {
        name: 'Groupement de critères',
        type: 'groupement-criteres'
      },
      { name: 'Diagnostique', type: 'string' },
      { 
        name : 'Ordonnances', children: [
          {
            name: 'Prescriptions', children: [
              { name: 'Nom du produit', type: 'string' },
              { name: 'Nom de la molécule', type: 'string' },
              { name: 'ATC Niveau 1', type: 'string' },
              { name: 'ATC Niveau 2', type: 'string' },
              { name: 'ATC Niveau 3', type: 'string' },
              { name: 'ATC Niveau 4', type: 'string' },
              { name: 'ATC Niveau 5', type: 'string' },
              { name: 'Commentaire', type: 'string' },
              { name: 'Motif', type: 'string' },
              { name: 'CIM10', type: 'string' }
            ]
          }
        ]
      }
      //{ name: 'Problème (maquette)', type: 'list' },
      //{ name: 'Code CIM10', type: 'string' },
    ]
  },
  {
    name: 'Documents',
    children: [
      { name: 'Titre du document', type: 'string' },
      { name: 'Type de document', type: 'type-document' }
    ]
  },
  /*{
    name: 'Traitement au long cours',
    children: [
  /*    { name: 'Classe thérapeutique long cours', type: 'list' },
      { name: 'Produit long cours', type: 'string' }
    ]
  },*/
  {
    name: 'Vaccin',
    type: 'vaccin'
  },
  {
    name: 'Alarme',
    type: 'string'
  },
  {
    name: 'Désensibilisation',
    type: 'desensibilisation'
  },
  {
    name: 'VSM',
    children: [
      { name: 'VSM période', type: 'duree' },
      { name: 'VSM écran', children: [
        { name: 'Fiche patient', type: 'ouinon' },
        { name: 'Accueil', type: 'ouinon' },
      ]},
    ]
  }
  /*{
    name: 'Affiliation',
    children: [
      { name: 'Numéro complet', type: 'number' },
      { name: 'Code régime', type: 'number' }
    ]
  },*/
];

export const stringType = [{ label: "Est égal à", value: "=" }, { label: "Est Différent de", value: "!=" }, { label: "Contient", value: "<>" }, { label: "Ne contient pas", value: "!<>" }, { label: "Commence par", value: "begins" }];
export const dateType = [{ label: "Est égal à", value: "=" }, { label: "Est Différent de", value: "!=" }, { label: "Est supérieur à", value: ">" }, { label: "Est supérieur ou égal à", value: ">=" }, { label: "Est inférieur à", value: "<" }, { label: "Est inférieur ou égal à", value: "<=" }];
export const numberType = [{ label: "Est égal à", value: "=" }, { label: "Est Différent de", value: "!=" }, { label: "Est supérieur à", value: ">" }, { label: "Est supérieur ou égal à", value: ">=" }, { label: "Est inférieur à", value: "<" }, { label: "Est inférieur ou égal à", value: "<=" }];
export const equalOrNotType = [{ label: "Est égal à", value: "=" }, { label: "Est Différent de", value: "!=" }];
export const existsOrNotType = [{ label: "Est égal à", value: "=" }, { label: "Est Différent de", value: "NOT EXISTS" }];
export const equalType = [{ label: "Est égal à", value: "=" }];
export const dureeType = [{label: "Est supérieur à", value: ">"},{label: "Est inférieur à", value: "<"}];

const sexeList = [{ label: "Féminin", value: "FEMME" }, { label: "Masculin", value: "HOMME" }, { label: "Indéterminé", value: "INDETERMINE" }];
const ouiNonList = [{ label: "Oui", value: "1" }, { label: "Non", value: "0" }];
const dureeList = [{ label: "Semaine(s)", value: "SEMAINE" }, { label: "Mois", value: "MOIS" }, { label: "Année(s)", value: "ANNEE" }];
const statutConsultationList = [
  { value: "actif", label: "Actif" },
  { value: "inactif", label: "Inactif" },
  { value: "resolu", label: "Résolu" }
];

@Injectable({
  providedIn: 'root'
})
export class RechercheMultiService {

  private isMock = environment.mock;

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };

  private apiUri = environment.basePath + '/patient/';
  private apiRechercheUri = environment.basePath + '/user/';

  constructor(private _http: HttpClient,
    private _filtresService: FiltresService,
    private _cabinet: CabinetService,
    private _correspondant: CorrespondantService,
    private _ref: ReferentielService,
    private _groupementSvc: GroupementCriteresService,
    private _critereSvc: CritereService,
    private _snack: SnackbarService,
    private _strUtilsSrv: StringUtilsService,
    private _protocoleSvc: MultiprofessionalProtocolService
  ) {
  }

  // Retourne la liste des critères de recherche
  getCriteres(): CritereNode[] {
    return TREE_DATA;
  }

  // Retourne le type de condition pour le critère de recherche
  getConditionsByTypeCritere(type: string): LabelValue[] {
    switch (type) {
      case 'string':
        return stringType;
      case 'date':
        return dateType;
      case 'number':
        return numberType;
      case 'historique':
      case 'pathologie':
      case 'allergie':
      case 'vaccin':
      case 'correspondant':
      case 'desensibilisation':
      case 'statut-consultation':
      case 'groupe-consultation':
      case 'type-consultation':
      case 'exist':
        return existsOrNotType;
      case 'groupement-criteres':
        return numberType;
      case 'critere':
        return numberType;
      case 'utilisateur':
      case 'sexe':
      case 'type-document':
      case 'protocole':
        return equalOrNotType;
      case 'ouinon':
        return equalType;
      case 'duree':
        return dureeType;
      default:
        return [];
    }
  }

  // Retourne si le critère est une saisie libre (false) ou une liste déroulante
  isTypeCritereIsList(type: string): boolean {
    switch (type) {
      case 'ald':
      case 'desensibilisation':
      case 'groupement-criteres':
      case 'critere':
      case 'historique':
      case 'pathologie':
      case 'allergie':
      case 'correspondant':
      case 'utilisateur':
      case 'sexe':
      case 'ouinon':
      case 'vaccin':
      case 'statut-consultation':
      case 'groupe-consultation':
      case 'type-consultation':
      case 'type-document':
      case 'duree':
      case 'protocole':
        return true;
      default:
        return false;
    }
  }

  isTypeCritereIsSubList(type: string): boolean {
    switch (type) {
      case 'groupement-criteres':
      case 'critere':
        return true;
      default:
        return false;
    }
  }

  async isCritereNumeric(type: string, id: string): Promise<boolean> {
    switch (type) {
      case 'groupement-criteres':
        const groupementCriteresList = await this._groupementSvc.findOneGroupementCriteres(id);
        if (groupementCriteresList && groupementCriteresList.criteres) {
          for (let des of groupementCriteresList.criteres) {
            if (des.type == TypeEnum.Alphanumerique) {
              return false;
            }
          }
        }
        return true;
      case 'critere':
        const criteresList = await this._critereSvc.findOne(id);
        if (criteresList && criteresList.type === 'alphanumerique') {
          return false;
        }
        return true;
    }
    return true;
  }

  // Retourne la liste de valeurs pour un critère
  async getValueListByTypeCritere(type: string): Promise<LabelValue[]> {
    switch (type) {
      case 'sexe':
        return sexeList;
      case 'duree':
        return dureeList;
      case 'utilisateur':
        const utilisateurs: LabelValue[] = [];
        const destinatairesCabinet = await this._cabinet.findCurrentCabinetDestinataire();
        for (let destinataire of destinatairesCabinet) {
          utilisateurs.push({ label: destinataire.nom, value: destinataire.id });
        }
        return utilisateurs;
      case 'correspondant':
        const corresponsants: LabelValue[] = [];
        const correspondantsCabinet = await this._correspondant.findAnnuaireCorrespondants();
        for (let correspondant of correspondantsCabinet) {
          corresponsants.push({ label: correspondant.nom.toLocaleUpperCase() + " " + this._strUtilsSrv.uppercaseFirstCharString(correspondant.prenom), value: correspondant.id });
        }
        return corresponsants;
      case 'pathologie':
        const pathologies: LabelValue[] = [];
        const pathologiesCabinet = await this._ref.findRefListTableHypermed(ReferentielEnum.pathologie);
        for (let patho of pathologiesCabinet) {
          pathologies.push({ label: patho.libelle, value: patho.id });
        }
        return pathologies;
      case 'allergie':
        const allergies: LabelValue[] = [];
        const allergiesCabinet = await this._ref.findRefListTable(ReferentielEnum.allergie);
        for (let patho of allergiesCabinet) {
          allergies.push({ label: patho.libelle, value: patho.id });
        }
        return allergies;
      case 'ald':
        const ald: LabelValue[] = [];
        const aldCabinet = await this._ref.findRefListTable(ReferentielEnum.ald);
        for (let patho of aldCabinet) {
          ald.push({ label: patho.libelle, value: patho.id });
        }
        return ald;
      case 'vaccin':
        const vaccins: LabelValue[] = [];
        const vaccinsCabinet = await this._ref.findRefListTable(ReferentielEnum.typeVaccin);
        for (let vac of vaccinsCabinet) {
          vaccins.push({ label: vac.libelle, value: vac.id });
        }
        return vaccins;
      case 'desensibilisation':
        const desensibilisations: LabelValue[] = [];
        const desensibilisationCabinet = await this._ref.findRefListTable(ReferentielEnum.typeVaccin);
        for (let des of desensibilisationCabinet) {
          desensibilisations.push({ label: des.libelle, value: des.id });
        }
        return desensibilisations;
      case 'groupement-criteres':
        const groupementCriteres: LabelValue[] = [];
        const groupementCriteresList = await this._groupementSvc.findGroupementCriteresList();
        for (let des of groupementCriteresList) {
          groupementCriteres.push({ label: des.titre, value: des.id });
        }
        return groupementCriteres;
      case 'critere':
        const criteres: LabelValue[] = [];
        const criteresList = await this._critereSvc.find();
        for (let des of criteresList.objects) {
          criteres.push({ label: des.name, value: des.id });
        }
        return criteres;
      case 'historique':
        const historiques: LabelValue[] = [];
        const historiqueCabinet = await this._ref.findRefListTableHypermed(ReferentielEnum.habitus);
        for (let des of historiqueCabinet) {
          historiques.push({ label: des.libelle, value: des.id });
        }
        return historiques;
      case 'type-consultation':
        const types: LabelValue[] = [];
        const typeConsult = await this._ref.findRefListTable(ReferentielEnum.typeConsultation);
        for (let des of typeConsult) {
          types.push({ label: des.libelle, value: des.id });
        }
        return types;
      case 'statut-consultation':
        return statutConsultationList;
      case 'groupe-consultation':
        const groupes: LabelValue[] = [];
        const groupeConsult = await this._ref.findRefListTable(ReferentielEnum.groupeConsultation);
        for (let des of groupeConsult) {
          groupes.push({ label: des.libelle, value: des.id });
        }
        return groupes;
      case 'ouinon':
        return ouiNonList;
      case 'type-document':
        const typesDocument: LabelValue[] = [];
        const typeDocuments = await this._ref.findRefListTableHypermed('RefTypeCodeDMP');
        for (let type of typeDocuments) {
          typesDocument.push({ label: type.libelle, value: type.id });
        }
        return typesDocument;
      case 'protocole':
        const protocoles: LabelValue[] = [
          { label: 'Non (aucun protocole)', value: '0' },
          { label: 'Oui (n\'importe quel protocole)', value: '1' }
        ];
        const currentProfil = JSON.parse(localStorage.getItem('currentProfil'));
        const protocolesPluri = await this._protocoleSvc.getAllMultiprofessionnalProtocols(currentProfil.id);
        for (let protocole of protocolesPluri.objects) {
          protocoles.push({ label: protocole.titre, value: protocole.id });
        }
        return protocoles;
      default:
        return [];
    }
  }

  // Lance la recherche vers le back
  public async rechercher(criteres: CritereRecherche[], pageFiltres: Filtres = {
    perpage: -1,
    currentPage: 1,
    sortOrder: SortEnum.ASC,
    sortBy: 'nom'
  }): Promise<Paginated<ResultatPatient>> {
    try {
      this.httpOptions.headers = this._filtresService.setHeaders(pageFiltres);
      const res = await this._http.post(this.apiUri + 'recherche', criteres, this.httpOptions).toPromise();
      
      // Gérer les deux formats de réponse
      let patients: ResultatPatient[];
      
      if (Array.isArray(res.body)) {
        //tableau direct
        patients = res.body as ResultatPatient[];
      } else if (res.body && (res.body as any).objects) {
        //objet avec propriété objects
        patients = (res.body as any).objects as ResultatPatient[];
      } else {
        //Format invalide ou erreur
        console.error('Format de réponse invalide:', res.body);
        patients = [];
      }
      
      const paginated: Paginated<ResultatPatient> = {
        page: Number(res.headers.get('x-page')),
        perpage: Number(res.headers.get('x-per-page')),
        total: Number(res.headers.get('x-total')),
        objects: patients
      }
      return paginated;
    } catch (error) {
      const errorMessage = error?.error?.message || error?.message || 'Une erreur est survenue lors de la recherche';
      this._snack.openSnackBar(errorMessage);
      
      // Retourner un objet vide pour éviter les crashes
      return {
        page: 1,
        perpage: 0,
        total: 0,
        objects: []
      };
    }
  }

  // Liste les recherches sauvegardees depuis le back
  public async listRecherches(pageFiltres: Filtres = {
    perpage: -1,
    currentPage: 1,
    sortOrder: SortEnum.ASC,
    sortBy: 'titre'
  }): Promise<Paginated<RechercheMultiCriteres>> {
    try {
      this.httpOptions.headers = this._filtresService.setHeaders(pageFiltres);
      const res = await this._http.get(this.apiRechercheUri + 'recherche-multi-criteres', this.httpOptions).toPromise();
      const recherches = res.body as RechercheMultiCriteres[];
      const paginated: Paginated<RechercheMultiCriteres> = {
        page: Number(res.headers.get('x-page')),
        perpage: Number(res.headers.get('x-per-page')),
        total: Number(res.headers.get('x-total')),
        objects: recherches
      }
      return paginated;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async getPatientVsmFromRechercheMultiCrit(pageFiltres: Filtres = {
    perpage: -1,
    currentPage: 1,
    sortOrder: SortEnum.ASC,
    sortBy: 'nomPrenom'
  }): Promise<Paginated<ResultatPatient>> {
    try {
      this.httpOptions.headers = this._filtresService.setHeaders(pageFiltres);
      const res = await this._http.get(this.apiRechercheUri + 'recherche-multi-criteres/vsm', this.httpOptions).toPromise();
      const patients = res.body as ResultatPatient[];
      const paginated: Paginated<ResultatPatient> = {
        page: Number(res.headers.get('x-page')),
        perpage: Number(res.headers.get('x-per-page')),
        total: Number(res.headers.get('x-total')),
        objects: patients
      }
      return paginated;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }
  
  public async listRecherchesForPatient(patientId: string, pageFiltres: Filtres = {
    perpage: -1,
    currentPage: 1,
    sortOrder: SortEnum.ASC,
    sortBy: 'titre'
  }): Promise<Paginated<RechercheMultiCriteres>> {
    try {
      this.httpOptions.headers = this._filtresService.setHeaders(pageFiltres);
      const res = await this._http.get(this.apiRechercheUri + 'recherche-multi-criteres/patient/' + patientId, this.httpOptions).toPromise();
      const recherches = res.body as RechercheMultiCriteres[];
      const paginated: Paginated<RechercheMultiCriteres> = {
        page: Number(res.headers.get('x-page')),
        perpage: Number(res.headers.get('x-per-page')),
        total: Number(res.headers.get('x-total')),
        objects: recherches
      }
      return paginated;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  // Sauvegarde une recherche dans le back
  public async saveRecherche(recherche: RechercheMultiCriteres): Promise<void> {
    try {
      await this._http.post(this.apiRechercheUri + 'recherche-multi-criteres', recherche, this.httpOptions).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  // Mise à jour d'une recherche dans le back
  public async updateRecherche(recherche: RechercheMultiCriteres): Promise<void> {
    try {
      await this._http.put(this.apiRechercheUri + 'recherche-multi-criteres/' + recherche.id, recherche, this.httpOptions).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  // Suppression d'une recherche dans le back
  public async deleteRecherche(rechercheId: string): Promise<void> {
    try {
      await this._http.delete(this.apiRechercheUri + 'recherche-multi-criteres/' + rechercheId, this.httpOptions).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  // Suppression d'une recherche dans le back
  public async enableRecherche(rechercheId: string, enable: boolean): Promise<void> {
    try {
      const options = {...this.httpOptions};
      let params = new HttpParams();
      params = params.append('enable', enable ? 'true' : 'false');
      (options as any).params = params;

      await this._http.put(this.apiRechercheUri + 'recherche-multi-criteres/enable/' + rechercheId, options).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  /**
   * Exporte les résultats de recherche en CSV via le backend
   * @param criteres Liste des critères de recherche
   * @returns Promise<Blob> Le fichier CSV retourné par le backend
   */
  public async exportRecherche(criteres: CritereRecherche[]): Promise<{
  code: number;
  message: string;
  value: string;
}> {
    try {
      const res = await this._http.post<{code: number;message: string;value: string;}>(this.apiRechercheUri + 'recherche-multi-criteres/export', criteres, this.httpOptions).toPromise();
      return res.body as {code: number; message: string; value: string;};
    } catch (error) {
      const errorMessage = error?.error?.message || error?.message || 'Erreur lors de l\'export CSV';
      this._snack.openSnackBar(errorMessage);
      throw error;
    }
  }
}
